export const GET_EVM_ADDRESS = `
import EVM from 0xEVM
access (all) fun main(address: Address): AnyStruct {
  let coaAddress = getAccount(address).capabilities.borrow<&EVM.CadenceOwnedAccount>(/public/evm)
  return coaAddress
}`
